import { createAction, props } from '@ngrx/store';

import { ISidebarNavigationOptions } from '../../sidebar/interfaces';

export const selectSidebarOptions = createAction('[Sidebar] Select Sidebar Options', props<{ options: ISidebarNavigationOptions }>());
export const clearSidebar = createAction('[Sidebar] Clear Sidebar');
